import { BACKEND_URL } from "@/lib/api";

/** Route Wikimedia/Wikipedia URLs through backend proxy (avoids hotlink blocks). */
export function proxied(url) {
  if (!url) return url;
  if (/^https:\/\/(upload\.wikimedia\.org|en\.wikipedia\.org|commons\.wikimedia\.org)\//.test(url)) {
    return `${BACKEND_URL}/api/image-proxy?url=${encodeURIComponent(url)}`;
  }
  return url;
}
